$( document ).ready(function() {
  $('.js-spl-review').slick({
    slidesToShow: 3,
    slidesToScroll: 3,
    arrows: false,
    dots: false,
  });
  
   $('.js-spl-slideshow').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    autoplay:true,
    autoplaySpeed:3000,
     adaptiveHeight: true
  });
  
  $('.slider-for').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    fade: true,
    dots: true,
    asNavFor: '.slider-nav'
  });
  $('.slider-nav').slick({
    slidesToShow: 5,
    slidesToScroll: 1,
    asNavFor: '.slider-for',
    dots: false,
    arrows: false,
    vertical: true,
    verticalSwiping: true,
    centerMode: false,
    focusOnSelect: true
  });
  $('.js-spl-cart').on('click',function(e){
    e.preventDefault();
    $('.spl-minicart').toggleClass('active');   
    $('.js-overlay-spl').toggleClass('active');
  });
  $('.js-spl-cart a').on('click',function(e){
    e.preventDefault();
  });

  $('.js-spl-close').on('click',function(e){
    e.preventDefault();
    $('.spl-minicart').removeClass('active');   
    $('.js-overlay-spl').removeClass('active');
  });
   $('.js-close-x').on('click',function(e){
    e.preventDefault();
    $('.spl-popup').addClass('hidden');
    $('.js-overlay-nll-spl').removeClass('active');
  });

  $('.js-overlay-spl').on('click',function(e){
    $('.spl-minicart').removeClass('active');   
    $('.js-overlay-spl').removeClass('active');
  });
  
  $('.js-overlay-nll-spl').on('click',function(e){
    $('.spl-popup').addClass('hidden');   
    $(this).removeClass('active');
  });
  
  $('.spl-swatch-swapper input[type=radio][name=id]').change(function() {
    var splPrice = $(this).attr('data-spl-swatch-price');
    $('.js-spl-price').text(splPrice);
  });
  
  function vl_back_to_top() {
    var backToTop = {
      element: $('.spl-btn-backtotop'),
      offset: 350,
      duration: 350
    };
    $(window).on('scroll', function() {
      if ($(this).scrollTop() > backToTop.offset) {
        backToTop.element.removeClass('is-hidden').addClass('is-visible');
      } else {
        backToTop.element.removeClass('is-visible').addClass('is-hidden');
      }
    });
    backToTop.element.on('click', function() {
      $('html, body').animate({
        scrollTop: 0
      }, backToTop.duration);
      return false;
    });
  }
  
  vl_back_to_top();
  
  
  function updateElements(){
    Shopify.getCart(function(cart){
      var fmt = function(v){ return Shopify.formatMoney(v, theme.money_format).replace(/\s/g, ''); };
      var totalHtml = '';
      if(cart.total_discount > 0){
        totalHtml += '<span style="text-decoration:line-through;color:#a89f99;font-weight:400;margin-right:6px;">' + fmt(cart.original_total_price) + '</span>';
      }
      totalHtml += fmt(cart.total_price);
      $('.js-total-price-drawer-cart').html(totalHtml);
      $('.js-spl-cart-count').text(cart.item_count);
      if(cart.total_discount > 0){
        $('.js-spl-cart-savings').html('-' + fmt(cart.total_discount));
        $('.spl-savings-row').show();
      } else {
        $('.spl-savings-row').hide();
      }
    })
  }
  $(document).on('click','.js-remove-drawer-cart',function(){
    var itemId = $(this).data('id');
    $(this).closest('.item-cart').fadeOut();
    Shopify.changeItem(itemId,0,updateElements);
  });
  
  $(document).on('click', '.spl-minicart-content .quantity-spl a[data-quantity=down], .spl-minicart-content .quantity-spl a[data-quantity=up]', function(e) {
    e.preventDefault();
    var parent = $(e.target).closest('.item-cart');
    var currentVal = parseInt(parent.find('input[name=quantity]').val());
    var currentVariant = parseInt(parent.find('input[name=quantity]').attr('data-id'));
    Shopify.changeItem(currentVariant,currentVal,updateElements);
  });
  
//   /* Popup */
//  	 var delay = 40500; //in milleseconds 

//    setTimeout(function(){ spl_showPopup(); }, delay);

//     $('.js-overlay-spl').on('click',function(){
//      $('.js-overlay-spl').removeClass('active');
//       spl_setCookie('spl-popup', 'popped', 30);
//     });

//   function spl_showPopup(){
//     if( spl_getCookie('spl-popup') == ""){
//        $('.js-overlay-spl').addClass('active');
//       spl_setCookie('spl-popup', 'popped', 30);
//     }
   
//   }

//   function spl_setCookie(cname,cvalue,exdays)
//   {
//     var d = new Date();
//     d.setTime(d.getTime()+(exdays*24*60*60*1000));
//     var expires = "expires="+d.toGMTString();
//     document.cookie = cname+"="+cvalue+"; "+expires+"; path=/";
//   }

//   function spl_getCookie(cname)
//   {
//     var name = cname + "=";
//     var ca = document.cookie.split(';');
//     for(var i=0; i<ca.length; i++) 
//     {
//       var c = jQuery.trim(ca[i]);
//       if (c.indexOf(name)==0) return c.substring(name.length,c.length);
//     }
//     return "";
//   }
 
});


